export async function warmupGpsBeforeSession(
  enabled: boolean,
  warmupGps: () => Promise<void>,
  timeoutMs: number
): Promise<void> {
  if (!enabled) return;
  await Promise.race([
    warmupGps(),
    new Promise<void>((resolve) => setTimeout(resolve, timeoutMs)),
  ]);
}
